/**
   * init.js sets the initial global variable declarations for the site's common libraries.
   * It is the first file declared in the site's 'generic-js-library' located in BASE_THEME/template.php
   * and should be handled with care.
   */
var $ = jQuery; var site = site || {}; var generic = generic || {}; var rb = rb || {}; var prodcat = prodcat || {};
